/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Resolve_StepsInputs */

const en_audit_resolve_steps = /** @type {(inputs: Audit_Resolve_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resolve blocked steps`)
};

const id_audit_resolve_steps = /** @type {(inputs: Audit_Resolve_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereskan langkah yang tertahan`)
};

/**
* | output |
* | --- |
* | "Resolve blocked steps" |
*
* @param {Audit_Resolve_StepsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const audit_resolve_steps = /** @type {((inputs?: Audit_Resolve_StepsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Resolve_StepsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_audit_resolve_steps(inputs)
	return en_audit_resolve_steps(inputs)
});